module.exports = __webpack_public_path__ + "img/icon213.0834ca10.png";